import {
  ButtonPayloadEnum,
  LinkPreviewComponent as TLinkPreviewComponent,
} from "@aichat/types/socket/widget.types";
import { LucideImage } from "lucide-react";
import { Typography } from "../../../typography";
import ButtonComponent from "../buttons/button-component";
import { stripHtmlTags, useFlags } from "@aichat/aichat-lib";
import { HandleSendComponentParams } from "@aichat/types/widget";

type LinkPreviewComponentProps = TLinkPreviewComponent & {
  // eslint-disable-next-line no-unused-vars
  handleSendComponent?: (params: HandleSendComponentParams) => void;
};

function LinkPreviewComponent({
  description,
  image,
  title,
  url,
  button_label,
  handleSendComponent,
}: LinkPreviewComponentProps) {
  const { add_to_cart_in_carousel } = useFlags([], ["add_to_cart_in_carousel"]);

  let link = "";
  try {
    link = new URL(url).hostname;
  } catch {
    link = url;
  }

  return (
    <div className="w-full">
      <div className="w-full h-full bg-background rounded-lg border border-secondary shadow-[0px_2px_4px_0px_#00000008,0px_1px_5px_-1px_#0000000F]">
        {image && image !== "#" ? (
          <img
            src={image}
            className="w-full aspect-video object-cover rounded-t-lg"
          />
        ) : (
          <div className="w-full aspect-video grid place-items-center bg-neutral-200 rounded-lg">
            <LucideImage />
          </div>
        )}
        <div className="p-2 flex gap-2 flex-col">
          <div className="flex flex-col gap-3">
            <div className="flex flex-col gap-1">
              <div className="flex flex-col gap-0">
                <Typography variant="subtleMedium">{title}</Typography>
                <Typography
                  variant="detail"
                  className="text-secondary-foreground line-clamp-2"
                >
                  {stripHtmlTags(description)}
                </Typography>
              </div>
              <Typography
                variant="tiny"
                className="text-muted-foreground line-clamp-1"
              >
                {link}
              </Typography>
            </div>

            <div className="flex items-start flex-col gap-2">
              <ButtonComponent
                payload={{
                  type: ButtonPayloadEnum.LINK,
                  value: url,
                }}
                className="w-full"
                variant="carouselPrimary"
              >
                {button_label ?? "View Item"}
              </ButtonComponent>
              {!!add_to_cart_in_carousel && (
                <ButtonComponent
                  onClick={() => {
                    if (!handleSendComponent) return;
                    handleSendComponent({
                      type: ButtonPayloadEnum.REPLY,
                      value: "Add to Cart",
                    });
                  }}
                  className="w-full"
                  variant="carouselPrimary"
                >
                  Add to Cart
                </ButtonComponent>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default LinkPreviewComponent;
